import { useViewport } from '@lamimed/pantheon';
import dynamic from 'next/dynamic';
import Head from 'next/head';

import { RequestDemo } from './containers';

import deskDemoImg from '/public/images/request_demo/desk.jpg';
import mobiDemoImg from '/public/images/request_demo/mobi.jpg';
import tabDemoImg from '/public/images/request_demo/tab.jpg';

const DemoWrapper = dynamic(
  async () => {
    const mod = await import('./containers/Wrapper');

    return mod.DemoWrapper;
  },
  { ssr: false },
);

const RequestDemoTemplate: React.FC = () => {
  const { lessThan } = useViewport();

  return (
    <>
      <Head>
        <title key="title">Richiedi una demo</title>
      </Head>

      <DemoWrapper
        desktopImage={lessThan('desktop') ? tabDemoImg : deskDemoImg}
        mobileImage={mobiDemoImg}
      >
        <RequestDemo />
      </DemoWrapper>
    </>
  );
};

export default RequestDemoTemplate;
